<template>
  <div class="body">
    <div class="skipNavigation">
      <a href="#g-contents">본문 바로가기</a>
      <a href="#g-menu">메뉴 바로가기</a>
    </div>
    <app-header/>
    <router-view name="bodyContent" :key="$route.path + componentKey"></router-view>
    <router-view name="searchContent" key="search"></router-view>
    <router-view name="myPooqLayout"></router-view>
    <router-view name="voucherLayout"></router-view>
    <router-view name="customerLayout" :key="$route.fullPath + componentKey"></router-view>
    <router-view name="adult_contents" key="adult_contents"></router-view>
    <ppv-toast></ppv-toast>
    <BtnTop />
    <app-footer/>
  </div>
</template>

<script>
import AppHeader from '@/components/common/AppHeader'
import AppFooter from '@/components/common/AppFooter'
import BtnTop from '@/components/button/BtnTop'
import { mapGetters } from 'vuex'
import {
  UPDATE_MAIN_LAYOUT_CONTENT,
  UPDATE_PAGING_CONTENT
} from '@/common/resources/const'
import PpvToast from '@/components/movie/PpvToast'
import { changeViewPort, VIEWPORT_VALUE_PC_APP_MODE } from '@/common/utils/viewport.utils'
export default {
  name: 'MainLayout',
  components: {
    PpvToast,
    AppHeader,
    AppFooter,
    BtnTop
  },
  data () {
    return {
      componentKey: 0
    }
  },
  computed: {
    ...mapGetters(['currentMenu'])
  },
  mounted () {
    this.$events.$on(UPDATE_PAGING_CONTENT, () => {
      this.componentKey += 1
    })
    this.$events.$on(UPDATE_MAIN_LAYOUT_CONTENT, () => {
      this.componentKey += 1
    })
  },
  beforeDestroy () {
    this.$events.$off(UPDATE_PAGING_CONTENT)
    this.$events.$off(UPDATE_MAIN_LAYOUT_CONTENT)
  },
  created () {
    changeViewPort(VIEWPORT_VALUE_PC_APP_MODE)
  }
}
</script>
<style lang="css" src="@/assets/css/main.css"></style>
